import React from 'react';
import { Button, Row, Col, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import NumberInput from '../../common/controls/numberInput';
import TextInput from '../../common/controls/textInput';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import Icon from '../../common/containers/icon';
const convert = millsValue => millsValue ? millsValue * 25.4 : millsValue;
const JobCoatingThicknessItem = _ref => {
  let data = _ref.data,
    specifiedThicknessUnits = _ref.specifiedThicknessUnits,
    index = _ref.index,
    onChange = _ref.onChange,
    propsOnRemove = _ref.onRemove;
  const handleChange = (name, value) => onChange("".concat(index, "/").concat(name), value);
  const handleChangeSpecifiedThicknessLow = value => handleChange('specifiedThicknessLow', value);
  const handleChangeSpecifiedThicknessHigh = value => handleChange('specifiedThicknessHigh', value);
  const specifiedThicknessLow = data.specifiedThicknessLow,
    specifiedThicknessHigh = data.specifiedThicknessHigh;
  const confirmOnRemoveFields = ['specifiedThicknessLow', 'specifiedThicknessHigh', 'specifiedThicknessDescription'];
  let low = specifiedThicknessLow;
  let high = specifiedThicknessHigh;
  if (specifiedThicknessUnits) {
    low = convert(low);
    high = convert(high);
  }
  low = low ? +low.toFixed(2) : low;
  high = high ? +high.toFixed(2) : high;
  const onRemove = () => propsOnRemove(index);
  // this calls onRemove IFF either
  //   a) there is no data to confirm removing in the item, or
  //   b) the user says it is okay to remove the all the data.
  const handleRemove = () => removeItemWithConfirm(data, 'thickness specification', confirmOnRemoveFields, onRemove);
  return /*#__PURE__*/React.createElement(Row, {
    className: "t-jcti-".concat(index)
  }, /*#__PURE__*/React.createElement(Col, {
    sm: 2
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "Low",
    value: low,
    entity: "ContractRequirementsThickness",
    field: "specifiedThicknessLow",
    onChange: handleChangeSpecifiedThicknessLow
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 2
  }, /*#__PURE__*/React.createElement(NumberInput, {
    label: "High",
    value: high,
    entity: "ContractRequirementsThickness",
    field: "specifiedThicknessHigh",
    onChange: handleChangeSpecifiedThicknessHigh
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    field: "specifiedThicknessDescription",
    data: data,
    onChange: handleChange,
    entity: "ContractRequirementsThickness"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 2
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    name: "removeSpecThickness",
    size: "sm",
    className: "form-control t-jct-remove tqc-control",
    onClick: handleRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Entry")));
};
JobCoatingThicknessItem.propTypes = {
  index: PropTypes.number.isRequired,
  specifiedThicknessUnits: PropTypes.number.isRequired,
  data: PropTypes.shape({
    id: PropTypes.string,
    specifiedThicknessLow: PropTypes.number,
    specifiedThicknessHigh: PropTypes.number,
    specifiedThicknessDescription: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default JobCoatingThicknessItem;